import React, { useCallback, useEffect, useReducer, useState } from "react"
import { obterPerguntas, salvarPerguntas } from "../../../services/pesquisaSatisfacao"
import useLoadingStore from "../../../stores/LoadingStore"
import { Loading } from "../../RegistradorDePedidos"
import { PerguntaPesquisaSatisfacaoInicial } from "../models/perguntaPesquisaSatisfacaoModel"
import { PerguntaPesquisaSatisfacaoActionsTypes } from "./perguntaPesquisaSatisfacaoActions"
import { PerguntaPesquisaSatisfacaoContext } from "./PerguntaPesquisaSatisfacaoContext"
import { perguntaPesquisaSatisfacaoReducer } from "./perguntaPesquisaSatisfacaoReducer"

export function PerguntaPesquisaSatisfacaoContextProvider({
    children,
}: {
    children: React.ReactNode
}) {
    const [dados, dispatch] = useReducer(
        perguntaPesquisaSatisfacaoReducer,
        PerguntaPesquisaSatisfacaoInicial
    )
    const [erroCarregamento, setErroCarregamento] = useState<string | null>(null)
    const setLoading = useLoadingStore(s => s.setLoading)

    const carregar = async () => {
        const autorizacao = localStorage.getItem("chaveSistema")
        if (!autorizacao) return
        try {
            setLoading(true)
            const response = await obterPerguntas(autorizacao)
            if ("retornoErro" in response) {
                setErroCarregamento(response.mensagem || "Erro ao carregar perguntas")
            } else {
                setErroCarregamento(null)
                const itens = response.map((p, i) => ({
                    localId: i + 1,
                    id: p.id,
                    descricao: p.descricao,
                    ordem: p.ordem,
                    tipo: p.tipo,
                }))
                dispatch({
                    type: PerguntaPesquisaSatisfacaoActionsTypes.CARREGAR,
                    payload: itens,
                })
            }
        } catch {
            setErroCarregamento("Erro ao carregar perguntas")
        } finally {
            setLoading(false)
        }
    }

    useEffect(() => {
        carregar()
    }, [])

    const salvar = useCallback(async () => {
        const autorizacao = localStorage.getItem("chaveSistema")
        if (!autorizacao) return
        try {
            setLoading(true)
            const payload = {
                perguntas: dados.perguntas.map(p => ({
                    id: p.id,
                    descricao: p.descricao,
                    ordem: p.ordem,
                    tipo: p.tipo,
                })),
                deletarIds: dados.pendingDelete,
            }
            const response = await salvarPerguntas(autorizacao, payload)
            if ("retornoErro" in response) {
                throw new Error(response.mensagem)
            }
            dispatch({
                type: PerguntaPesquisaSatisfacaoActionsTypes.CONFIRMAR_SAVE,
                payload: response,
            })
        } finally {
            setLoading(false)
        }
    }, [dados])

    return (
        <PerguntaPesquisaSatisfacaoContext.Provider
            value={{ dados, dispatch, salvar, erroCarregamento }}
        >
            <Loading />
            {children}
        </PerguntaPesquisaSatisfacaoContext.Provider>
    )
}
